import { Box, Typography } from "@mui/material";
import { useMemo } from "react";

import { useAppSelector } from "../../app/hooks";
import { ItemCategory } from "../../constants/enum/enum";
import { TravelRangeType } from "../../constants/enum/travel";
import { TravelTransport } from "../../constants/travel";
import { convertDateTimeSimple } from "../../utils/utils";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import useStyles from "./index.styles";

interface TransportListItemProps {
  travelType: string;
  icon: string;
  travelRangeType: TravelRangeType;
  travelTime: number;
  cost: number;
  owned: boolean;
  traveling: boolean;
}

const TransportListItem = ({
  travelType,
  icon,
  travelRangeType,
  travelTime,
  cost,
  owned,
  traveling,
}: TransportListItemProps) => {
  const { classes } = useStyles();

  const renderAction = () => {
    if (travelType === "Train")
      return (
        <>
          <CheckIcon
            sx={{
              width: 16,
              color: "green!important",
            }}
          />
          <Typography color="green!important">Public</Typography>
        </>
      );

    return owned ? (
      <>
        <CheckIcon
          sx={{
            width: 16,
            color: "green!important",
          }}
        />
        <Typography color="green!important">Owned</Typography>
      </>
    ) : (
      <>
        <CloseIcon
          sx={{
            width: 16,
            color: "red!important",
          }}
        />

        <Typography color="!important">Not Owned</Typography>
      </>
    );
  };

  return (
    <Box className={classes.transportListItem}>
      <Box className={classes.transportListItemHeader}>
        <Typography>{travelType}</Typography>
        <Box className={classes.transportListItemOwnLabel}>
          {renderAction()}
        </Box>
      </Box>
      <Box className={classes.transportListItemInfo}>
        <Box
          component="img"
          src={icon}
          className={classes.transportListItemImage}
        />
        <Box className={classes.transportListItemDetail}>
          <Typography>Every {convertDateTimeSimple(travelTime)}</Typography>
          <Typography>
            {travelRangeType === TravelRangeType.LocalTravel
              ? "Current region"
              : "All regions"}
          </Typography>
          <Box className={classes.transportListItemCost}>
            <Typography>Cost</Typography>
            <Box component="img" src={"/assets/imgs/layout/currency.png"} />
            <Typography>{cost}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const TravelTransportList: React.FC = () => {
  const { classes } = useStyles();
  const { myInventoryItems, userTravelInfo } = useAppSelector(
    (state) => state.profile
  );

  const hasAirplane = useMemo(
    () =>
      myInventoryItems.some(
        (item) => item.categoryId === ItemCategory.SHOPITEM && item.typeId === 9
      ),
    [myInventoryItems]
  );

  const hasCarBike = useMemo(
    () =>
      myInventoryItems.some(
        (item) =>
          item.categoryId === ItemCategory.SHOPITEM &&
          (item.typeId === 8 || item.typeId === 5)
      ),
    [myInventoryItems]
  );

  return (
    <Box className={classes.transportListPanel}>
      {Object.values(TravelTransport).map((item, index) => (
        <TransportListItem
          key={index}
          {...item}
          owned={
            item.travelType === "Train" ||
            (item.travelType === "Airplane" &&
              (hasAirplane || userTravelInfo?.travelType === 2)) ||
            (item.travelType === "Car/Motorcycle" &&
              (hasCarBike || userTravelInfo?.travelType === 1))
          }
          traveling={!!userTravelInfo && userTravelInfo.travelType === item.id}
        />
      ))}
    </Box>
  );
};

export default TravelTransportList;
